export const API_KEY = '2f62d309c1b64fe6bc1173955222105';
